import { memo } from "react";

interface MinusIconProps {
  className?: string;
}

/**
 * Minus icon component for decrement actions
 */
export const MinusIcon = memo(function MinusIcon({ className }: MinusIconProps) {
  return (
    <svg
      width="13"
      height="3"
      viewBox="0 0 13 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M11.7953 1.31039L0.657221 1.31039C0.482871 1.31039 0.315662 1.37965 0.192378 1.50294C0.0690936 1.62622 -0.000166588 1.79343 -0.000167178 1.96778C-0.000167099 2.14213 0.0690934 2.30934 0.192377 2.43263C0.315662 2.55591 0.482872 2.62517 0.657221 2.62517L11.7953 2.62517C11.9697 2.62517 12.1369 2.55591 12.2602 2.43263C12.3834 2.30934 12.4527 2.14213 12.4527 1.96778C12.4527 1.79343 12.3834 1.62622 12.2602 1.50294C12.1369 1.37965 11.9697 1.31039 11.7953 1.31039Z" />
    </svg>
  );
});
